import { useRouteMatch } from 'react-router'
import { Route, Switch } from 'react-router-dom'

import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import { ropSubRoutes } from 'routes/desktopRoutes'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import { RopTabs } from '../Rop/components/RopTabs/RopTabs'

const HomeRopDesktop = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <PageContainerDesktop>
          <RopTabs />
        </PageContainerDesktop>
      </Route>

      {ropSubRoutes.map(route => (
        <SubPrivateRoute {...route} key={route.path} />
      ))}
    </Switch>
  )
}
export default HomeRopDesktop
